@file:OptIn(ExperimentalUuidApi::class)

package com.appcreator.client.firebase.storage

import androidx.compose.runtime.Composable
import coil3.PlatformContext
import coil3.compose.LocalPlatformContext
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.core.ReadonlyEnvStore
import com.appcreator.blueprint.firebase.storage.FirebaseStorageUploadImageAction
import com.appcreator.compose.LocalInputEnvStore
import com.appcreator.compose.actions.Performer
import com.appcreator.compose.platformPrintout
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.storage.File
import dev.gitlive.firebase.storage.storage
import dev.gitlive.firebase.storage.storageMetadata
import io.github.vinceglb.filekit.FileKit
import io.github.vinceglb.filekit.PlatformFile
import io.github.vinceglb.filekit.dialogs.FileKitMode
import io.github.vinceglb.filekit.dialogs.FileKitType
import io.github.vinceglb.filekit.dialogs.openFilePicker
import io.github.vinceglb.filekit.extension
import io.github.vinceglb.filekit.name
import kotlin.uuid.ExperimentalUuidApi

class UploadImagePerformer(private val action: FirebaseStorageUploadImageAction): Performer {

    @Composable
    override fun deferred(): Performer.Deferred {
        val inputStore = LocalInputEnvStore.current
        val context = LocalPlatformContext.current
        return object : Performer.Deferred {
            override suspend fun perform(envStore: EnvStore) {
                val (type, title) = when {
                    action.allowImages == true && action.allowVideos == true -> FileKitType.ImageAndVideo to "Pick a file"
                    action.allowVideos == true -> FileKitType.Video to "Pick a video"
                    else -> FileKitType.Image to "Pick an image"
                }

                println("UploadImagePerformer openFilePicker")


                FileKit.openFilePicker(
                    type = type,
                    mode = FileKitMode.Single,
                    title = title
                )?.let { file ->

                    println("UploadImagePerformer start ${envStore.env}")

                    var tempFile: File? = null
                    try {

                        val (upload, mimeType) = if (file.isHeic()) {
                            file.heicToJpeg(context).also { tempFile = it } to "image/jpeg"
                        } else {
                            file.toFile() to file.getMimeTypeFromExtension()
                        }
                        if(upload == null || mimeType == null) throw IllegalStateException("Unknown file type $file")

                        val metadata = storageMetadata {
                            contentType = mimeType
                            if (!action.cacheControl.isNullOrEmpty()) {
                                cacheControl = action.cacheControl
                            }
                        }

                        val extension = if(file.isHeic()) "jpg" else file.extension
                        val envStore = ReadonlyEnvStore.create(
                            envStore, mapOf(
                                "newFileName" to file.name,
                                "newFileExtension" to extension,
                            )
                        )

                        val name = if(action.imageName?.isNotBlank() == true) {
                            envStore.injectVariables(action.imageName!!)
                        } else file.name


                        action.uploading?.let { progressOutput ->
                            inputStore.set(progressOutput.value, "true")
                        }

                        val ref = Firebase.storage.reference.child(name)
                        ref.putFile(upload, metadata)

                        // Doesn't work on iOS
//                        val progressFlow = ref.putFileResumable(upload, metadata)
//                        try {
//                            progressFlow.collectLatest {
//                                action.progressOutput?.let { progressOutput ->
//                                    println("Progress ${it.bytesTransferred} ${it.totalByteCount}")
//
//                                    val progress = (it.bytesTransferred.toLong() * 100) / it.totalByteCount.toLong()
//                                    inputStore.set(progressOutput.value, progress.coerceAtLeast(1).toString())
//                                }
//                            }
//                        } catch (ex: Exception) {
//                            println("UploadImagePerformer progressFlow ${ex.message}")
//                            ex.platformPrintout()
//                        }

                        val url = ref.getDownloadUrl() // This should make sure this fails if upload didn't complete
                        action.selectedFile?.let {
                            inputStore.set(it.value, file.toPath())
                        }
                        action.urlOutput?.let {
                            inputStore.set(it.value, url)
                        }
                        println("Setting blob id a ${action.blobId?.value} to $name")

                        action.blobId?.let {
                            println("Setting blob id b ${it.value} to $name")
                            inputStore.set(it.value, name)
                        }

                    } catch (e: Exception) {
                        e.platformPrintout()
                        throw e
                    } finally {
                        action.uploading?.let { progressOutput ->
                            inputStore.set(progressOutput.value, "false")
                        }
                        tempFile?.delete()
                    }
                }?: println("UploadImagePerformer openFilePicker is null")
            }
        }
    }
}

private fun PlatformFile.isHeic() = extension == "heic" || extension == "heif"

expect fun PlatformFile.getMimeTypeFromExtension(): String?
expect fun PlatformFile.toFile(): File
expect fun PlatformFile.heicToJpeg(context: PlatformContext): File?
expect fun PlatformFile.toPath(): String
expect fun File.delete()
